import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import DataSource from '../DataSource'
import globals from '../globals'
import LoadingOverlay from './LoadingOverlay'
import Button from '../elements/Button'
import ReactModal from '../modules/ReactModal'

const DeleteAccountHistory = (props) => {
    const [showDeleteModal, setShowDeleteModal] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [isDeleted, setIsDeleted] = useState(false)
    const [hasError, setHasError] = useState(false)
    const [hasDuplicateError, setHasDuplicateError] = useState(false)

    const handleDeleteHistory = event => {
        event.preventDefault()
        setHasError(false)
        setShowDeleteModal(false)
        setHasDuplicateError(false)
        setIsLoading(true)
        DataSource.postData(
            '/api/postGdprRequest',
            {
                serviceId: props.serviceId,
                requestType: 'delete'
            },
            response => {
                globals.pushEvent('HsDeleteHistory')
                setIsLoading(false)
                setIsDeleted(true)
            }, error => {
                setIsLoading(false)
                if (error.response.status === 422 || error.response.status === 401) {
                    if (isDuplicateError(error)) {
                        setHasDuplicateError(true)
                    } else {
                        props.handleExpiredToken()
                    }
                } else {
                    setHasError(true)
                    globals.handleError(error.message, { info: 'Error trying to delete home secure account history', serviceId: props.serviceId, error: error })
                }
            }
        )

    }

    const isDuplicateError = error => {
        return (
            error.response.data.errors &&
            error.response.data.errors.requestType &&
            error.response.data.errors.requestType[0] &&
            error.response.data.errors.requestType[0].includes('Duplicate request')
        )
    }

    const handleShowModal = event => {
        event.preventDefault()
        setShowDeleteModal(true)
    }

    const handleCloseModal = event => {
        event.preventDefault()
        setShowDeleteModal(false)
    }

    const AccountHistory = () => {
        if (isDeleted) {
            return <div className='form-success'>Your account history is being deleted. This can take up to 24 hours to finalise. We'll send you an email when it's done.</div>
        } else {
            return (
                <LoadingOverlay isLoading={isLoading}>
                    <Button title='Delete account history' action={handleShowModal} />
                    <div className='text-center text-lg-left font-small mt-3'>
                        You can delete your entire account history from our Home Secure servers at any time. Please note this will reset all Home Secure reporting.
                    </div>
                </LoadingOverlay>
            )
        }
    }

    return (
        <React.Fragment>
            {AccountHistory()}
            {hasError && <div className='row-error mt-2'>An error occurred, please try again.</div>}
            {hasDuplicateError && <div className='row-error mt-2'>Your account history deletion is already in process.</div>}
            <ReactModal showModal={showDeleteModal} handleCloseModal={() => setShowDeleteModal(false)} heading='Confirmation'>
                <div className='row'>
                    <div className='col-12 text-center'>
                        <p className='mt-0 mb-4'>Please confirm you would like to <span className='bold'>delete your account history</span> for this Home Secure service?</p>
                        <p className='mt-0 mb-4 color-red sub-bold'>Note: this cannot be undone.</p>
                        <div className='d-flex justify-content-center'>
                            <Button title='Confirm' action={handleDeleteHistory} className='mr-3' />
                            <Button title='Cancel' action={handleCloseModal} color='red' />
                        </div>
                    </div>
                </div>
            </ReactModal>
        </React.Fragment>
    )
}

DeleteAccountHistory.propTypes = {

}

DeleteAccountHistory.propTypes = {
    serviceId: PropTypes.number.isRequired,
    handleExpiredToken: PropTypes.func.isRequired
}

const mapStateToProps = state => ({
    isVerified: state.verifiedUser.isVerified,
    verifiedToken: state.verifiedUser.verifiedToken
})

export default connect(mapStateToProps)(DeleteAccountHistory)



// WEBPACK FOOTER //
// ./resources/js/components/DeleteAccountHistory.js